export const effectsDropshadowDefaults = { 
	'dropshadow-offset': '0rem',
	'dropshadow-color': 'rgba(0,0,0,.85)',
	'dropshadow-blur-radius': '0rem',
}